import { gql } from "@apollo/client";

export const LOGIN = gql`
  mutation ($email: String!, $password: String!) {
    login(input: { email: $email, password: $password }) {
      token
      roles
      permissions {
        name
      }
    }
  }
`;
export const LOGIN_WITH_CAPTCHA = gql`
  mutation ($email: String!, $password: String!, $captcha_token: String!) {
    loginWithCaptcha(
      email: $email
      password: $password
      captcha_token: $captcha_token
    ) {
      token
      roles
      permissions {
        name
      }
    }
  }
`;
export const CREATE_NEW_ACCOUNT = gql`
  mutation CreateNew(
    $name: String!
    $phone: String!
    $email: String
    $password: String!
    $password_confirmation: String!
    $profile_image: Upload
    $role: String!
  ) {
    createNew(
      name: $name
      phone: $phone
      email: $email
      password: $password
      password_confirmation: $password_confirmation
      profile_image: $profile_image
      role: $role
    ) {
      id
      name
      phone
      email
      status
      role
      profile_image
    }
  }
`;

export const VERIFY_PHONE = gql`
  mutation VerifyPhone($phone: String!, $otp: String!) {
    verifyOtp(phone: $phone, otp: $otp) {
      message
      user {
        id
        phone
        status
      }
    }
  }
`;
export const CHECK_USER_BY_PHONE = gql`
  mutation CheckUserByPhone($phone: String!) {
    checkUserByPhone(phone: $phone) {
      status
      phone
    }
  }
`;
export const RESEND_OTP = gql`
  mutation resendOtp($phone: String!) {
    resendOtp(phone: $phone) {
      message
    }
  }
`;
export const CREATE_MICROFINANCE = gql`
  mutation CreateMicrofinance(
    $name: String!
    $phone_number: String!
    $max_loan_amount: Float!
    $interest_rate: Float!
    $loan_repayment_duration: Int!
    $loan_repayment_duration_type: RepaymentDurationType!
  ) {
    createMicrofinance(
      name: $name
      phone_number: $phone_number
      max_loan_amount: $max_loan_amount
      interest_rate: $interest_rate
      loan_repayment_duration: $loan_repayment_duration
      loan_repayment_duration_type: $loan_repayment_duration_type
    ) {
      id
      name
      status
      loan_repayment_duration
      loan_repayment_duration_type
    }
  }
`;
export const UPDATE_MICROFINANCE = gql`
  mutation UpdateMicrofinance(
    $id: ID!
    $name: String
    $phone_number: String
    $max_loan_amount: Float
    $interest_rate: Float
    $loan_repayment_duration: Int
    $loan_repayment_duration_type: RepaymentDurationType
  ) {
    updateMicrofinance(
      id: $id
      name: $name
      phone_number: $phone_number
      max_loan_amount: $max_loan_amount
      interest_rate: $interest_rate
      loan_repayment_duration: $loan_repayment_duration
      loan_repayment_duration_type: $loan_repayment_duration_type
    ) {
      id
      name
      phone_number
      max_loan_amount
      interest_rate
      loan_repayment_duration
      loan_repayment_duration_type
      status
      created_at
    }
  }
`;
export const TOGGLE_MICROFINANCE_STATUS = gql`
  mutation ToggleStatus($id: ID!) {
    toggleMicrofinanceStatus(id: $id) {
      id
      name
      status
    }
  }
`;
export const DELETE_MICROFINANCE = gql`
  mutation DeleteMicrofinance($id: ID!) {
    deleteMicrofinance(id: $id) {
      id
      name
    }
  }
`;

export const CREATE_LOAN_PROVIDER = gql`
  mutation CreateLoanProvider(
    $name: String!
    $code: String!
    $user_phone: String!
    $user_email: String!
    $user_password: String!
    $description: String
    $contact_email: String
    $contact_phone: String
    $website: String
    $api_base_url: String
  ) {
    createLoanProvider(
      name: $name
      code: $code
      user_phone: $user_phone
      user_email: $user_email
      user_password: $user_password
      description: $description
      contact_email: $contact_email
      contact_phone: $contact_phone
      website: $website
      api_base_url: $api_base_url
    ) {
      id
      user_id
      name
      code
      status
      created_at
    }
  }
`;

export const UPDATE_LOAN_PROVIDER = gql`
  mutation UpdateLoanProvider(
    $id: ID!
    $name: String
    $code: String
    $description: String
    $logo_url: String
    $contact_email: String
    $contact_phone: String
    $website: String
    $api_base_url: String
    $status: Int
  ) {
    updateLoanProvider(
      id: $id
      name: $name
      code: $code
      description: $description
      logo_url: $logo_url
      contact_email: $contact_email
      contact_phone: $contact_phone
      website: $website
      api_base_url: $api_base_url
      status: $status
    ) {
      id
      user_id
      name
      code
      description
      logo_url
      contact_email
      contact_phone
      website
      status
      created_at
      updated_at
    }
  }
`;

export const TOGGLE_LOAN_PROVIDER_STATUS = gql`
  mutation ToggleLoanProviderStatus($provider_id: ID!) {
    toggleLoanProviderStatus(provider_id: $provider_id) {
      id
      name
      code
      status
      updated_at
    }
  }
`;

export const DELETE_LOAN_PROVIDER = gql`
  mutation DeleteLoanProvider($id: ID!) {
    deleteLoanProvider(id: $id) {
      id
      name
    }
  }
`;

export const CREATE_LOAN_CATEGORY = gql`
  mutation CreateLoanCategory(
    $name: String!
    $description: String
    $icon: String
    $sort_order: Int
    $provider_id: ID
    $status: Int
  ) {
    createLoanCategory(
      name: $name
      description: $description
      icon: $icon
      sort_order: $sort_order
      provider_id: $provider_id
      status: $status
    ) {
      id
      name
      status
      provider_id
      provider {
        id
        name
        code
      }
    }
  }
`;

export const UPDATE_LOAN_CATEGORY = gql`
  mutation UpdateLoanCategory(
    $id: ID!
    $name: String
    $description: String
    $icon: String
    $sort_order: Int
    $provider_id: ID
    $status: Int
  ) {
    updateLoanCategory(
      id: $id
      name: $name
      description: $description
      icon: $icon
      sort_order: $sort_order
      provider_id: $provider_id
      status: $status
    ) {
      id
      name
      description
      icon
      sort_order
      status
      provider {
        id
        name
        code
      }
    }
  }
`;

export const DELETE_LOAN_CATEGORY = gql`
  mutation DeleteLoanCategory($id: ID!) {
    deleteLoanCategory(id: $id) {
      id
      name
    }
  }
`;

export const CREATE_LOAN_PRODUCT = gql`
  mutation CreateLoanProduct(
    $name: String!
    $description: String
    $interest_type: String
    $interest_rate: Float!
    $repayment_frequency: String
    $min_amount: Float!
    $max_amount: Float!
    $min_term: Int
    $max_term: Int
    $processing_fee_type: String
    $processing_fee: Float!
    $penalty_rate: Float
    $grace_period_days: Int
    $category_id: ID
    $provider_id: ID
    $allowed_terms: String
  ) {
    createLoanProduct(
      name: $name
      description: $description
      interest_type: $interest_type
      interest_rate: $interest_rate
      repayment_frequency: $repayment_frequency
      min_amount: $min_amount
      max_amount: $max_amount
      min_term: $min_term
      max_term: $max_term
      processing_fee_type: $processing_fee_type
      processing_fee: $processing_fee
      penalty_rate: $penalty_rate
      grace_period_days: $grace_period_days
      category_id: $category_id
      provider_id: $provider_id
      allowed_terms: $allowed_terms
    ) {
      id
      name
      interest_type
      interest_rate
      min_amount
      max_amount
      status
    }
  }
`;

export const UPDATE_LOAN_PRODUCT = gql`
  mutation UpdateLoanProduct(
    $id: ID!
    $name: String
    $description: String
    $interest_type: String
    $interest_rate: Float
    $repayment_frequency: String
    $min_amount: Float
    $max_amount: Float
    $min_term: Int
    $max_term: Int
    $processing_fee_type: String
    $processing_fee: Float
    $penalty_rate: Float
    $grace_period_days: Int
    $category_id: ID
    $provider_id: ID
    $allowed_terms: String
  ) {
    updateLoanProduct(
      id: $id
      name: $name
      description: $description
      interest_type: $interest_type
      interest_rate: $interest_rate
      repayment_frequency: $repayment_frequency
      min_amount: $min_amount
      max_amount: $max_amount
      min_term: $min_term
      max_term: $max_term
      processing_fee_type: $processing_fee_type
      processing_fee: $processing_fee
      penalty_rate: $penalty_rate
      grace_period_days: $grace_period_days
      category_id: $category_id
      provider_id: $provider_id
      allowed_terms: $allowed_terms
    ) {
      id
      name
      description
      interest_type
      interest_rate
      repayment_frequency
      min_amount
      max_amount
      status
    }
  }
`;

export const DELETE_LOAN_PRODUCT = gql`
  mutation DeleteLoanProduct($id: ID!) {
    deleteLoanProduct(id: $id) {
      id
      name
    }
  }
`;

export const TOGGLE_LOAN_PRODUCT_STATUS = gql`
  mutation ($product_id: ID!) {
    toggleLoanProductStatus(product_id: $product_id) {
      id
      name
      status
    }
  }
`;
//caregory mutations
export const CREATE_CATEGORY = gql`
  mutation (
    $image: Upload
    $name: String!
    $children: [CreateCategoryChilderenInput!]!
  ) {
    createCategory(
      input: { name: $name, image: $image, children: { create: $children } }
    ) {
      id
      name
    }
  }
`;
export const CREATE_Attribute = gql`
  mutation ($name: String!, $category_id: String!) {
    createAttribute(input: { name: $name, category_id: $category_id }) {
      id
      name
    }
  }
`;
export const UPDATE_Attribute = gql`
  mutation ($id: ID!, $name: String!, $category_id: String!) {
    updateAttribute(
      id: $id
      input: { name: $name, category_id: $category_id }
    ) {
      id
      name
      category {
        id
        name
      }
    }
  }
`;

export const DEL_CATEGORY = gql`
  mutation DEL_CATEGORY($id: ID!) {
    deleteCategory(id: $id) {
      id
    }
  }
`;
export const DEL_SALES = gql`
  mutation DEL_SALES($id: ID!) {
    deleteSales(id: $id) {
      id
    }
  }
`;
export const DEL_STAFF = gql`
  mutation DEL_STAFF($id: ID!) {
    deleteStaff(id: $id) {
      id
    }
  }
`;
export const DEL_Attribute = gql`
  mutation DEL_Attribute($id: ID!) {
    deleteAttribute(id: $id) {
      id
    }
  }
`;
export const DEL_Product_CATEGORY = gql`
  mutation DEL_PRODUCT_CATEGORY($id: ID!) {
    deleteSupplierProductCategory(id: $id) {
      id
    }
  }
`;
export const DEL_ASSIGNED = gql`
  mutation ($id: String!) {
    deleteAssignedWarehouse(id: $id) {
      id
    }
  }
`;
export const DEL_Values = gql`
  mutation DEL_PRODUCT_Values($id: ID!) {
    deleteAttributeValue(id: $id) {
      id
    }
  }
`;
export const UPDATE_CATEGORY = gql`
  mutation UPDATE_CATEGORY(
    $id: ID!
    $image: Upload
    $name: String!
    $children: UpdateCategoryHasMany
  ) {
    updateCategory(
      id: $id
      input: { name: $name, image: $image, children: $children }
    ) {
      id
      name
      imageUrl
      image {
        id
        original_url
      }
      children_count

      children {
        id
        name
        imageUrl
      }
    }
  }
`;

// ware houses
export const CREATE_WARE_HOUSE = gql`
  mutation CREATE_WARE_HOUSE(
    $name: String!
    $_geo: GeoInput
    $regionId: ID!
    $specific_area: String
    $supplier_id: String!
  ) {
    createWarehouse(
      input: {
        name: $name
        _geo: $_geo
        region: { connect: $regionId }
        specific_area: $specific_area
        supplier_id: $supplier_id
      }
    ) {
      id
      specific_area
    }
  }
`;
export const UPDATE_WARE_HOUSE = gql`
  mutation UPDATE_WARE_HOUSE(
    $id: ID!
    $name: String!
    $_geo: GeoInput!
    $specific_area: String!
    $region: UpdateRegionBelongsTo!
    $supplier_id: String!
  ) {
    updateWarehouse(
      id: $id
      name: $name
      _geo: $_geo
      specific_area: $specific_area
      region: $region
      supplier_id: $supplier_id
    ) {
      id
      name
      _geo {
        lat
        lng
      }
      specific_area
      region {
        id
        name
      }
    }
  }
`;

export const DEL_WAREHOUSE = gql`
  mutation DEL_WAREHOUSE($id: ID!) {
    deleteWarehouse(id: $id) {
      id
      name
      _geo {
        lat
        lng
      }
    }
  }
`;

// distributor mutations
export const CREATE_DISTRIBUTOR = gql`
  mutation CREATE_DISTRIBUTOR(
    $name: String!
    $address: String!
    $_geo: GeoInput
    $city: String
    $contact_name: String!
    $contact_phone: String!
    $contact_email: String
    $region: CreateRegionBelongsTo!
    $user: CreateUserBelongsTo!
  ) {
    createDistributor(
      input: {
        name: $name
        address: $address
        _geo: $_geo
        city: $city
        contact_name: $contact_name
        contact_phone: $contact_phone
        contact_email: $contact_email
        region: $region
        user: $user
      }
    ) {
      id
      name
    }
  }
`;
export const UPDATE_DISTRIBUTOR = gql`
  mutation UPDATE_DISTRIBUTOR(
    $id: ID!
    $name: String!
    $address: String!
    $_geo: GeoInput
    $city: String
    $contact_name: String!
    $contact_phone: String!
  ) {
    updateDistributor(
      id: $id
      input: {
        name: $name
        address: $address
        _geo: $_geo
        city: $city
        contact_name: $contact_name
        contact_phone: $contact_phone
      }
    ) {
      id
      name
      contact_phone
      _geo {
        lat
        lng
      }
      city
      contact_name
    }
  }
`;
export const DEL_DISTRIBUTOR = gql`
  mutation DEL_DISTRIBUTOR($id: ID!) {
    deleteDistributor(id: $id) {
      id
      name
    }
  }
`;

// region related mutation retailer
export const CREATE_REGIONS = gql`
  mutation create_regions($name: String!) {
    createRegion(input: { name: $name }) {
      id
      name
    }
  }
`;

export const UPDATE_REGION = gql`
  mutation update_region($id: ID!, $name: String!) {
    updateRegion(id: $id, input: { name: $name }) {
      id
      name
    }
  }
`;

export const DEL_REGION = gql`
  mutation ($id: ID!) {
    deleteRegion(id: $id) {
      id
      name
    }
  }
`;

export const CREATE_PRODUCT = gql`
  mutation CREATE_PRODUCT(
    $name: String!
    $product_type: String!
    $minimum_order_quantity: Int
    $supplier_business_id: String
    $short_description: String!
    $description: String!
    $images: [Upload]
    $category: CreateCategoryHasOne!
    $is_active: Boolean
    $attributes: CreateProductAttributes
    $sell_price: Float
    $buy_price: Float
  ) {
    createProduct(
      input: {
        name: $name
        product_type: $product_type
        minimum_order_quantity: $minimum_order_quantity
        supplier_business_id: $supplier_business_id
        short_description: $short_description
        description: $description
        is_active: $is_active
        images: $images
        category: $category
        attributes: $attributes
        sell_price: $sell_price
        buy_price: $buy_price
      }
    ) {
      id
    }
  }
`;

export const CHANGE_STATUS = gql`
  mutation ($id: ID!, $status: String!) {
    changeProductReturnStatus(id: $id, status: $status) {
      id
      status
    }
  }
`;
export const UPDATE_PRODUCT = gql`
  mutation UPDATE_PRODUCT(
    $id: ID!
    $name: String!
    $supplier_business_id: String
    $minimum_order_quantity: Int
    $short_description: String!
    $description: String!
    $images: UpdateProductImagesInput
    $category: CreateCategoryHasOne!
    $is_active: Boolean
    $buy_price: Float
    $sell_price: Float
    $attributes: [UpdateProductAttributesInput!]
  ) {
    updateProduct(
      id: $id
      input: {
        name: $name
        buy_price: $buy_price
        sell_price: $sell_price
        minimum_order_quantity: $minimum_order_quantity
        supplier_business_id: $supplier_business_id
        short_description: $short_description
        description: $description
        is_active: $is_active
        images: $images
        category: $category
        attributes: $attributes
      }
    ) {
      id
      name
      product_type
      skus {
        id
        sku
        sell_price
        buy_price
      }
      description
      discount {
        discount_value
      }
      supplier {
        id
        business_name
      }
      category {
        id
        name
      }
      productSkusCount
      short_description
      images {
        id
        original_url
        is_default
      }
      attributes {
        id
        name
        values {
          id
          value
        }
      }
    }
  }
`;

export const DEL_PRODUCT = gql`
  mutation DEL_PRODUCT($id: ID!) {
    deleteProduct(id: $id) {
      id
      name
    }
  }
`;

//product skus

export const CREATE_PRODUCT_SKUS = gql`
  mutation ($product_id: ID!, $variants: [ProductSkuCreateInput!]!) {
    createProductSku(product_id: $product_id, input: { variants: $variants }) {
      id
      sku
    }
  }
`;
export const UPDATE_PRODUCT_SKUS = gql`
  mutation UPDATE_PRODUCT_SKUS(
    $id: ID!
    $buy_price: Float
    $sell_price: Float
    $attribute_value_ids: [String!]!
    $is_active: Boolean
  ) {
    updateProductSku(
      id: $id
      input: {
        buy_price: $buy_price
        sell_price: $sell_price
        attribute_value_ids: $attribute_value_ids
        is_active: $is_active
      }
    ) {
      id
      sell_price
      buy_price
      variants {
        id
        value
        attribute {
          id
          name
        }
      }
    }
  }
`;
export const UPDATE_BasicSupplierBusinessInfo = gql`
  mutation UPDATE_BasicSupplierBusinessInfo(
    $id: ID!
    $business_email: String
    $business_phone_number: String
    $business_website: String
    $business_region_id: String
    $business_zone: String
    $business_woreda: String
    $business_kebele: String
    $owner_firstname: String
    $owner_middlename: String
    $owner_lastname: String # ✅ Add this line
    $owner_phone_number: String
  ) {
    updateBasicSupplierBusinessInfo(
      id: $id
      input: {
        business_email: $business_email
        business_phone_number: $business_phone_number
        business_website: $business_website
        business_region_id: $business_region_id
        business_zone: $business_zone
        owner_lastname: $owner_lastname
        business_woreda: $business_woreda
        business_kebele: $business_kebele
        owner_firstname: $owner_firstname
        owner_middlename: $owner_middlename
        owner_phone_number: $owner_phone_number
      }
    ) {
      id
      supplier_code
      business_kebele
      business_zone
      owner_lastname
      business_woreda
      owner_firstname
      owner_middlename
      owner_phone_number
      business_name
      business_email
      business_website
      business_phone_number
      business_type
      status
    }
  }
`;
export const ADMIN_UPDATE_BasicSupplierBusinessInfo = gql`
  mutation ADMIN_UPDATE_BasicSupplierBusinessInfo(
    $id: ID!
    $business_name: String
    $business_type: String
    $owner_id_type: String
    $tin: String
    $number_of_warehouses: Int
    $business_registration_number: String
    $trade_license_document: Upload
    $tin_certification_document: Upload
    $owner_id: Upload
  ) {
    updateSupplierBusiness(
      id: $id
      input: {
        business_name: $business_name
        business_type: $business_type
        owner_id_type: $owner_id_type
        tin: $tin
        number_of_warehouses: $number_of_warehouses
        business_registration_number: $business_registration_number
        trade_license_document: $trade_license_document
        tin_certification_document: $tin_certification_document
        owner_id: $owner_id
      }
    ) {
      id
      supplier_code
      business_kebele
      owner_id_type
      business_zone
      business_woreda
      owner_firstname
      owner_middlename
      owner_phone_number
      business_name
      business_email
      business_website
      business_phone_number
      owner_lastname
      business_type
      business_region {
        id
        name
      }

      business_geo_location {
        lat
        lng
      }
      number_of_warehouses
      tin
      status
      owner_id_url
      trade_license_document_url
      tin_certification_document_url
      business_registration_number
      created_at
    }
  }
`;

export const DEL_PRODUCT_SKU = gql`
  mutation DEL_PRODUCT_SKU($id: ID!) {
    deleteProductSku(id: $id) {
      id
    }
  }
`;
//retailer
export const CREATE_RETAILER = gql`
  mutation create_retailer(
    $name: String!
    $address: String!
    $_geo: GeoInput
    $city: String
    $contact_name: String!
    $contact_phone: String!
    $contact_email: String
    $region: CreateRegionBelongsTo!
    $user: CreateUserBelongsTo!
  ) {
    createRetailer(
      input: {
        name: $name
        address: $address
        _geo: $_geo
        city: $city
        contact_name: $contact_name
        contact_phone: $contact_phone
        contact_email: $contact_email
        region: $region
        user: $user
      }
    ) {
      id
      name
    }
  }
`;
export const CREATE_WAREHOUSE_MANAGER = gql`
  mutation createWarehouseManager(
    $name: String!
    $phone: String!
    $email: String!
    $password: String!
    $password_confirmation: String!
    $warehouse_id: String!
  ) {
    createWarehouseManager(
      input: {
        name: $name
        phone: $phone
        email: $email
        password: $password
        password_confirmation: $password_confirmation
        warehouse_id: $warehouse_id
      }
    ) {
      id
      warehouse {
        name
      }
      user {
        name
        phone
        email
      }
    }
  }
`;
export const CREATE_SUPPLIER = gql`
  mutation createSupplier(
    $name: String!
    $address: String!
    $city: String!
    $phone: String!
    $email: String!
    $password: String!
    $password_confirmation: String!
  ) {
    createSupplier(
      input: {
        name: $name
        address: $address
        city: $city
        phone: $phone
        email: $email
        password: $password
        password_confirmation: $password_confirmation
      }
    ) {
      id
      city
      address
      user {
        name
        phone
        email
      }
    }
  }
`;
export const CREATE_SUPPLIER_Business = gql`
  mutation createSupplierBusiness(
    $business_name: String!
    $business_email: String
    $business_phone_number: String
    $business_website: String
    $business_type: String
    $business_region_id: String!
    $business_zone: String
    $business_woreda: String!
    $business_kebele: String
    $owner_firstname: String
    $owner_middlename: String
    $owner_lastname: String
    $owner_phone_number: String
    $owner_id_type: String
    $tin: String!
    $number_of_warehouses: Int!
    $business_registration_number: String
    $trade_license_document: Upload
    $tin_certification_document: Upload!
    $owner_id: Upload!
    $is_agreed: Boolean!
  ) {
    createSupplierBusiness(
      input: {
        business_name: $business_name
        business_email: $business_email
        business_phone_number: $business_phone_number
        business_website: $business_website
        business_type: $business_type
        business_region_id: $business_region_id
        business_zone: $business_zone
        business_woreda: $business_woreda
        business_kebele: $business_kebele
        owner_firstname: $owner_firstname
        owner_middlename: $owner_middlename
        owner_phone_number: $owner_phone_number
        owner_id_type: $owner_id_type
        tin: $tin
        owner_lastname: $owner_lastname
        number_of_warehouses: $number_of_warehouses
        business_registration_number: $business_registration_number
        trade_license_document: $trade_license_document
        tin_certification_document: $tin_certification_document
        owner_id: $owner_id
        is_agreed: $is_agreed
      }
    ) {
      id
    }
  }
`;
export const CREATE_SUPPLIER_commission = gql`
  mutation createSupplierCommission(
    $supplier_id: String!
    $payment_mode: String!
    $calculation_type: String!
    $subscription_fee_amount: Float
    $commission_rate: Float
    $fee_interval: String
    $fee_on_date: Date
  ) {
    createSupplierConfiguration(
      input: {
        supplier_id: $supplier_id
        payment_mode: $payment_mode
        calculation_type: $calculation_type
        commission_rate: $commission_rate
        subscription_fee_amount: $subscription_fee_amount
        fee_interval: $fee_interval
        fee_on_date: $fee_on_date
      }
    ) {
      id
      commission_rate
      supplier {
        user {
          name
          phone
        }
      }
    }
  }
`;
export const CREATE_SUPPLIER_PAYOUT = gql`
  mutation (
    $supplier_id: String!
    $amount: Float!
    $reference: String!
    $payment_method: String!
  ) {
    createSupplierPayout(
      input: {
        supplier_id: $supplier_id
        amount: $amount
        reference: $reference
        payment_method: $payment_method
      }
    ) {
      id
      amount
    }
  }
`;
export const UPDATE_SUPPLIER_PAYOUT = gql`
  mutation (
    $id: ID!
    $supplier_id: String!
    $amount: Float!
    $reference: String!
    $payment_method: String!
  ) {
    updateSupplierPayout(
      id: $id
      input: {
        supplier_id: $supplier_id
        amount: $amount
        reference: $reference
        payment_method: $payment_method
      }
    ) {
      id
      payment_method
      amount
      reference
      status
      supplier {
        id
        user {
          name
          phone
          email
        }
      }
    }
  }
`;
export const REFUND = gql`
  mutation ($id: String!) {
    refundCheckoutTransaction(id: $id) {
      id
      payment_method
      amount
      commission
      txn_ref
      status
      created_at
      is_reversed
      orders {
        id
      }
    }
  }
`;
export const ASSIGN_WAREHOUSE = gql`
  mutation ($id: String!, $warehouse_ids: [String!]!) {
    assignWarehouses(id: $id, warehouse_ids: $warehouse_ids) {
      id
      user {
        name
        phone
      }
    }
  }
`;
export const CREATE_PRODUCT_CATEGORIES = gql`
  mutation createSupplierProductCategory(
    $supplier_business_id: String!
    $category_ids: [String!]
  ) {
    createSupplierProductCategory(
      input: {
        supplier_business_id: $supplier_business_id
        category_ids: $category_ids
      }
    ) {
      category {
        name
      }
      supplier {
        business_name
        business_type
        business_phone_number
      }
    }
  }
`;

export const CREATE_Value = gql`
  mutation addAttributeValue($id: ID!, $values: [String!]!) {
    addAttributeValue(id: $id, input: { values: $values }) {
      id
      value
    }
  }
`;
export const Update_Value = gql`
  mutation updateAttributeValue($id: ID!, $value: String!) {
    updateAttributeValue(id: $id, input: { value: $value }) {
      id
      value
    }
  }
`;
export const CREATE_Shipping = gql`
  mutation createWarehouseShippingEstimation(
    $warehouse_id: String
    $category_id: String!
    $period_type: String!
    $min_period: Int!
    $max_period: Int!
  ) {
    createWarehouseShippingEstimation(
      input: {
        warehouse_id: $warehouse_id
        category_id: $category_id
        period_type: $period_type
        min_period: $min_period
        max_period: $max_period
      }
    ) {
      id
    }
  }
`;

export const UPDATE_RETAILER = gql`
  mutation update_retailer(
    $id: ID!
    $name: String!
    $address: String!
    $_geo: GeoInput
    $city: String
    $contact_name: String!
    $contact_phone: String!
  ) {
    updateRetailer(
      id: $id
      input: {
        name: $name
        address: $address
        _geo: $_geo
        city: $city
        contact_name: $contact_name
        contact_phone: $contact_phone
      }
    ) {
      id
      name
      _geo {
        lat
        lng
      }
      city
      contact_name
      address
    }
  }
`;
export const UPDATE_SUPPLIER = gql`
  mutation update_retailer(
    $id: ID!
    $name: String!
    $address: String!
    $city: String!
    $phone: String!
    $email: String
  ) {
    updateSupplier(
      id: $id
      input: {
        name: $name
        address: $address
        city: $city
        phone: $phone
        email: $email
      }
    ) {
      id
      user {
        name
        phone
        email
      }
      address
      city
    }
  }
`;
export const UPDATE_Manager = gql`
  mutation update_manager(
    $id: ID!
    $name: String!
    $phone: String!
    $email: String
    $warehouse_id: String!
  ) {
    updateWarehouseManager(
      id: $id
      input: {
        name: $name
        phone: $phone
        email: $email
        warehouse_id: $warehouse_id
      }
    ) {
      id
      warehouse {
        name
      }
      user {
        name
        phone
        email
      }
    }
  }
`;

export const UPDATE_SHIPPING = gql`
  mutation update_shipping(
    $id: ID!
    $category_id: String
    $period_type: String!
    $min_period: Int!
    $max_period: Int!
  ) {
    updateWarehouseShippingEstimation(
      id: $id
      input: {
        category_id: $category_id
        period_type: $period_type
        min_period: $min_period
        max_period: $max_period
      }
    ) {
      id
      category {
        name
      }
      warehouse {
        name
      }
      period_type
      min_period
      max_period
    }
  }
`;

export const UPDATE_SUPPLIER_Commistion = gql`
  mutation updateSupplierConfiguration(
    $id: ID!
    $supplier_id: String!
    $payment_mode: String!
    $calculation_type: String
    $subscription_fee_amount: Float
    $commission_rate: Float
    $fee_interval: String
    $fee_on_date: Date
  ) {
    updateSupplierConfiguration(
      id: $id
      input: {
        supplier_id: $supplier_id
        payment_mode: $payment_mode
        calculation_type: $calculation_type
        commission_rate: $commission_rate
        subscription_fee_amount: $subscription_fee_amount
        fee_interval: $fee_interval
        fee_on_date: $fee_on_date
      }
    ) {
      id
      commission_rate
      payment_mode
      calculation_type
      subscription_fee_amount
      fee_interval
      fee_on_date
      supplier {
        business_name
        user {
          name
          phone
          email
        }
      }
    }
  }
`;

export const DEL_RETAILER = gql`
  mutation DEL_RETAILER($id: ID!) {
    deleteRetailer(id: $id) {
      id
      name
      _geo {
        lat
        lng
      }
      city
      contact_name
    }
  }
`;
export const DEL_AGENT = gql`
  mutation DeleteAgentSupplier($id: ID!) {
    deleteAgentSupplier(id: $id) {
      id
      retailer {
        id
      }
      supplier {
        id
      }
    }
  }
`;
export const DEL_SUPPLIER = gql`
  mutation DEL_SUPPLIER($id: ID!) {
    deleteSupplier(id: $id) {
      id
    }
  }
`;
export const DEL_BUSINESS = gql`
  mutation DEL_BUSINESS($id: ID!) {
    deleteSupplierBusiness(id: $id) {
      id
    }
  }
`;
export const DEL_SUPPLIER_PAYOUT = gql`
  mutation ($id: ID!) {
    deleteSupplierPayout(id: $id) {
      id
    }
  }
`;
export const DEL_MANAGER = gql`
  mutation DEL_MANAGER($id: ID!) {
    deleteWarehouseManager(id: $id) {
      id
    }
  }
`;
export const DEL_Shipping = gql`
  mutation DEL_SHIPPING($id: ID!) {
    deleteWarehouseShippingEstimation(id: $id) {
      id
    }
  }
`;
export const DEL_SUPPLIER_Commission = gql`
  mutation DEL_SUPPLIER_Commission($id: ID!) {
    deleteSupplierConfiguration(id: $id) {
      id
    }
  }
`;

//stock

export const CREATE_STOCK = gql`
  mutation CREATE_STOCK(
    $quantity: Int!
    $minimum_stock_level: Int!
    $product_sku_id: String!
    $warehouse_id: String
  ) {
    createStock(
      input: {
        quantity: $quantity
        minimum_stock_level: $minimum_stock_level
        product_sku_id: $product_sku_id
        warehouse_id: $warehouse_id
      }
    ) {
      id
    }
  }
`;
export const ACCEPT_SHIPMENT_REQUEST = gql`
  mutation ACCEPT_SHIPMENT_REQUEST($shipment_id: ID!, $driver_id: ID!) {
    acceptShipmentRequest(shipment_id: $shipment_id, driver_id: $driver_id) {
      id
    }
  }
`;
export const MANAGE_STOCK = gql`
  mutation MANAGE_STOCK(
    $stock_id: ID!
    $type: StockManagementActionType!
    $reason: String!
    $quantity: Int!
  ) {
    stockManagementAction(
      input: {
        stock_id: $stock_id
        type: $type
        reason: $reason
        quantity: $quantity
      }
    ) {
      id
      reason
    }
  }
`;
export const UPDATE_IMAGE = gql`
  mutation UPDATE_IMAGE($image_id: String!) {
    setImageProductAsDefault(image_id: $image_id) {
      id
      name
    }
  }
`;
export const DEL_STOCK = gql`
  mutation ($id: ID!) {
    deleteStock(id: $id) {
      id
    }
  }
`;

//shipment
export const CREATE_SHIPMENT = gql`
  mutation CREATE_SHIPMENT(
    $arrival_time: DateTime!
    $departure_time: DateTime!
    $cost: Float!
    $from: CreateShipmentFromMorphTo!
    $to: CreateShipmentToMorphTo!
  ) {
    createShipment(
      input: {
        arrival_time: $arrival_time
        departure_time: $departure_time
        cost: $cost
        from: $from
        to: $to
      }
    ) {
      id
      arrival_time
      departure_time
      status
    }
  }
`;

export const MANAGE_SHIPMENT = gql`
  mutation MANAGE_SHIPMENT(
    $id: ID!
    $arrival_time: DateTime!
    $departure_time: DateTime!
    $cost: Float!
    $status: ShipmentStatusType!
    $from: UpdateShipmentFromMorphTo!
    $to: UpdateShipmentToMorphTo!
  ) {
    updateShipment(
      id: $id
      input: {
        arrival_time: $arrival_time
        departure_time: $departure_time
        cost: $cost
        status: $status
        from: $from
        to: $to
      }
    ) {
      id
    }
  }
`;
export const DEL_SHIPMENT = gql`
  mutation DEL_SHIPMENT($id: ID!) {
    deleteShipment(id: $id) {
      id
    }
  }
`;

export const SHIP_ITEM = gql`
  mutation SHIP_ITEM(
    $shipment: CreateShipmentBelongsTo!
    $shipment_itemable: [CreateShipmentItemableMorphTo]!
  ) {
    createShipmentItems(
      input: { shipment: $shipment, shipment_itemable: $shipment_itemable }
    ) {
      id
      shipment {
        id
        arrival_time
      }
    }
  }
`;

//wallet mutuation
export const CONFIRM_DEPOSIT_SLIP = gql`
  mutation ($deposit_id: ID!) {
    confirmDepositSlip(deposit_id: $deposit_id) {
      id
    }
  }
`;
export const DIS_APPROVE_DEPOSIT_SLIP = gql`
  mutation ($deposit_id: ID!) {
    diapproveDepositWithSlip(deposit_id: $deposit_id) {
      id
    }
  }
`;
export const CREATE_VEHICLE_TYPE = gql`
  mutation (
    $title: String!
    $type: String!
    $starting_price: Float!
    $image: Upload
    $price_per_kilometer: Float!
  ) {
    createVehicleType(
      input: {
        title: $title
        type: $type
        starting_price: $starting_price
        image: $image
        price_per_kilometer: $price_per_kilometer
      }
    ) {
      id
    }
  }
`;

export const DEL_VEHICLE_TYPES = gql`
  mutation ($id: ID!) {
    deleteVehicleType(id: $id) {
      id
      title
    }
  }
`;

export const UPDATE_VEHICLE_TYPE = gql`
  mutation (
    $id: ID!
    $title: String!
    $type: String!
    $starting_price: Float
    $image: Upload
    $price_per_kilometer: Float
  ) {
    updateVehicleType(
      id: $id
      input: {
        title: $title
        type: $type
        image: $image
        starting_price: $starting_price
        price_per_kilometer: $price_per_kilometer
      }
    ) {
      id
      title
      status
      image
      type
      starting_price
      price_per_kilometer
      vehicleCount
      created_at
    }
  }
`;

export const CREATE_DROP_OFF = gql`
  mutation CREATE_DROP_OFF(
    $vehicleType: CreateVehicleTypeBelongsTo!
    $from: CreateDropoffFromMorphTo!
    $orders: CreateDropoffOrdersInput!
  ) {
    createDropoff(
      input: { vehicle_type: $vehicleType, from: $from, orders: $orders }
    ) {
      id
    }
  }
`;
export const MARK_AS_DELIVERED_SELF_SHIPMENT = gql`
  mutation MARK_AS_DELIVERED_SELF_SHIPMENT($shipment_id: ID!) {
    markAsDeliveredSelfShipment(shipment_id: $shipment_id) {
      id
      status
    }
  }
`;
//drivers
export const CREATE_DRIVER = gql`
  mutation (
    $name: String!
    $city: String
    $phone: String!
    $email: String!
    $password: String!
    $password_confirmation: String!
    $region_id: String!
  ) {
    createDriver(
      input: {
        name: $name
        city: $city
        phone: $phone
        email: $email
        region_id: $region_id
        password_confirmation: $password_confirmation
        password: $password
      }
    ) {
      id
    }
  }
`;
export const DRIVER_SELF_REGISTRATION = gql`
  mutation (
    $name: String!
    $city: String
    $phone: String!
    $email: String!
    $password: String!
    $password_confirmation: String!
    $region_id: String!
  ) {
    driverSelfRegisteration(
      input: {
        name: $name
        city: $city
        phone: $phone
        email: $email
        region_id: $region_id
        password: $password
        password_confirmation: $password_confirmation
      }
    ) {
      id
    }
  }
`;
export const UPDATE_SALES = gql`
  mutation (
    $id: ID!
    $name: String
    $email: String
    $address: String
    $phone: String
    $city: String
    $sub_city: String
    $woreda: String
    $gender: String
    $region_id: String
    $profile_image: Upload
  ) {
    updateSales(
      id: $id
      input: {
        name: $name
        address: $address
        phone: $phone
        city: $city
        email: $email
        gender: $gender
        region_id: $region_id
        woreda: $woreda
        sub_city: $sub_city
        profile_image: $profile_image
      }
    ) {
      id
      user {
        name
        email
        profile_image
        phone
      }
      city
      region {
        id
        name
      }
      address
      sub_city
      woreda
    }
  }
`;
export const UPDATE_DRIVER = gql`
  mutation (
    $id: ID!
    $region_id: String!
    $email: String!
    $name: String!
    $city: String!
    $phone: String!
  ) {
    updateDriver(
      id: $id
      input: {
        name: $name
        email: $email
        region_id: $region_id
        city: $city
        phone: $phone
      }
    ) {
      id
    }
  }
`;

export const DEL_DRIVER = gql`
  mutation ($id: ID!) {
    deleteDriver(id: $id) {
      id
      name
    }
  }
`;

//vehicle
export const CREATE_VEHICLE = gql`
  mutation (
    $model: String!
    $plate_number: String!
    $color: String!
    $owner_name: String!
    $owner_phone: String!
    $libre_number: String
    $plate_doc: Upload
    $license_doc: Upload
    $libre_doc: Upload
    $business_certificate_doc: Upload
    $tin_certificate_doc: Upload
    $license_number: String
    $vehicle_type: CreateVehicleTypeBelongsTo!
    $driver: CreateDriverBelongsTo!
    $region: CreateRegionBelongsTo!
  ) {
    createVehicle(
      model: $model
      plate_number: $plate_number
      color: $color
      owner_name: $owner_name
      owner_phone: $owner_phone
      libre_number: $libre_number
      plate_doc: $plate_doc
      license_doc: $license_doc
      libre_doc: $libre_doc
      business_certificate_doc: $business_certificate_doc
      tin_certificate_doc: $tin_certificate_doc
      vehicle_type: $vehicle_type
      driver: $driver
      region: $region
      license_number: $license_number
    ) {
      id
      model
      plate_number
      owner_name
      libre_number
      plate_doc
      license_doc
      license_number
      libre_doc
      business_certificate_doc
      tin_certificate_doc
    }
  }
`;

export const UPDATE_VEHICLE = gql`
  mutation (
    $id: ID!
    $model: String!
    $plate_number: String!
    $color: String!
    $owner_name: String!
    $owner_phone: String!
    $region: CreateRegionBelongsTo!
    $driver: CreateDriverBelongsTo!
    $vehicle_type: CreateVehicleTypeBelongsTo!
    $plate_doc: Upload
    $license_doc: Upload
    $libre_doc: Upload
    $libre_number: String
  ) {
    updateVehicle(
      id: $id

      model: $model
      plate_number: $plate_number
      color: $color
      owner_name: $owner_name
      owner_phone: $owner_phone
      region: $region
      driver: $driver
      vehicle_type: $vehicle_type
      plate_doc: $plate_doc
      license_doc: $license_doc
      libre_doc: $libre_doc
      libre_number: $libre_number
    ) {
      id
      color
      owner_name
      owner_phone
      plate_number
      plate_doc
      license_doc
      libre_doc
      libre_number
      vehicle_type {
        title
      }
      driver {
        id
        user {
          name
        }
      }
    }
  }
`;
export const DEL_VEHICLE = gql`
  mutation ($id: ID!) {
    deleteVehicle(id: $id) {
      id
    }
  }
`;
export const LOGOUT = gql`
  mutation {
    logout {
      status
    }
  }
`;

//user mutations

export const DEL_USER = gql`
  mutation ($id: ID!) {
    deleteUser(id: $id) {
      id
      name
      email
    }
  }
`;
export const DEL_PAYMENT_TYPE = gql`
  mutation ($id: ID!) {
    deletePaymentType(id: $id) {
      id
    }
  }
`;
export const CHANGE_USER_STATUS = gql`
  mutation ChangeUserStatus($id: ID!, $status: String!) {
    changeUserStatus(id: $id, status: $status) {
      id
      name
      status
    }
  }
`;
export const APPROVE_LOAN = gql`
  mutation ApproveLoanRequest($id: ID!, $microfinance_id: ID) {
    approveLoanRequest(id: $id, microfinance_id: $microfinance_id) {
      id
      status
      approved_by {
        id
        name
      }
      approved_at
    }
  }
`;
export const MAKER_ACCEPT_LOAN = gql`
  mutation MakerAcceptLoan($application_id: ID!, $remark: String) {
    makerAcceptLoan(application_id: $application_id, remark: $remark) {
      id
      status
      workflow_status
      maker_id
      maker_remark
      maker_submitted_at
    }
  }
`;
export const MAKER_REJECT_LOAN = gql`
  mutation MakerRejectLoan($application_id: ID!, $remark: String!) {
    makerRejectLoan(application_id: $application_id, remark: $remark) {
      id
      status
      workflow_status
      maker_id
      maker_remark
    }
  }
`;
export const CHECKER_VERIFY_LOAN = gql`
  mutation CheckerVerifyLoan($application_id: ID!, $remark: String) {
    checkerVerifyLoan(application_id: $application_id, remark: $remark) {
      id
      status
      workflow_status
      maker_id
      checker_id
      checker_action
      checker_remark
      checker_acted_at
    }
  }
`;
export const CHECKER_DISBURSE_LOAN = gql`
  mutation CheckerDisburseLoan($application_id: ID!) {
    checkerDisburseLoan(application_id: $application_id) {
      id
      trx
      application_id
      user_id
      principal
      total_payable
      status
      disbursed_at
    }
  }
`;
export const Change_Supplier_BusinessStatus = gql`
  mutation ChangeUserStatus($id: ID!, $status: String!) {
    changeSupplierBusinessStatus(id: $id, status: $status) {
      id
      status
    }
  }
`;

export const CHANGE_VEHICLE_TYPE_STATUS = gql`
  mutation ChangeVehicleTypeStatus($id: ID!, $status: String!) {
    changeVehicleTypeStatus(id: $id, status: $status) {
      id
      status
    }
  }
`;
export const CHANGE_WAREHOUSE_STATUS = gql`
  mutation ChangeWarehouseStatus($id: ID!, $status: String!) {
    changeWarehouseStatus(id: $id, status: $status) {
      id
      status
    }
  }
`;
export const RECALL_DRIVER_FOR_PENDING_DROPOFF = gql`
  mutation RecallDriverForPendingDropoff($dropoff_id: ID!) {
    recallDriverForPendingDropoff(dropoff_id: $dropoff_id) {
      id
    }
  }
`;
export const ASSIGN_DRIVER_TO_DROPOOF = gql`
  mutation ($driver_id: ID!, $dropoff_id: ID!) {
    assignDriverToDropoff(driver_id: $driver_id, dropoff_id: $dropoff_id) {
      id
    }
  }
`;
export const CALL_DRIVER_FOR_ORDER = gql`
  mutation CALL_DRIVER_FOR_ORDER($id: ID!) {
    confirmOrderForDelivery(id: $id) {
      id
    }
  }
`;
export const CREATE_USER = gql`
  mutation (
    $name: String!
    $email: String!
    $password: String!
    $phone: String!
    $profile_image: Upload
    $password_confirmation: String!
    $role: String!
  ) {
    createUser(
      input: {
        name: $name
        email: $email
        phone: $phone
        password: $password
        password_confirmation: $password_confirmation
        role: $role
        profile_image: $profile_image
      }
    ) {
      id
      name
    }
  }
`;
export const CREATE_DISCOUNT = gql`
  # discount value type: PERCENTAGE, FLAT
  mutation (
    $product_id: String!
    $discount_value_type: String!
    $discount_value: Float!
    $start_date: Date!
    $end_date: Date
  ) {
    createProductDiscount(
      input: {
        product_id: $product_id
        discount_value_type: $discount_value_type
        discount_value: $discount_value
        start_date: $start_date
        end_date: $end_date
      }
    ) {
      id
    }
  }
`;
export const UPDATE_DISCOUNT = gql`
  mutation (
    $id: ID!
    $discount_value_type: String!
    $discount_value: Float!
    $start_date: Date!
    $end_date: Date
  ) {
    updateProductDiscount(
      id: $id
      input: {
        discount_value_type: $discount_value_type
        discount_value: $discount_value
        start_date: $start_date
        end_date: $end_date
      }
    ) {
      id
      discount_value_type
      discount_value
      start_date
      end_date
      product {
        id
        name
      }
    }
  }
`;
export const DEL_DISCOUNT = gql`
  mutation ($id: ID!) {
    deleteProductDiscount(id: $id) {
      id
    }
  }
`;
export const CREATE_SALES = gql`
  mutation (
    $name: String!
    $email: String!
    $password: String!
    $address: String!
    $phone: String!
    $city: String!
    $sub_city: String
    $woreda: String!
    $gender: String!
    $region_id: String!
    $profile_image: Upload
  ) {
    createSales(
      input: {
        name: $name
        address: $address
        phone: $phone
        city: $city
        email: $email
        gender: $gender
        password: $password
        region_id: $region_id
        woreda: $woreda
        sub_city: $sub_city
        profile_image: $profile_image
      }
    ) {
      id
      user {
        name
        email
        phone
      }
    }
  }
`;
export const CREATE_STAFF = gql`
  mutation CreateStaff(
    $name: String!
    $phone: String!
    $email: String
    $password: String!
    $business_ids: [ID!]!
    $warehouse_ids: [ID!]
  ) {
    createStaff(
      name: $name
      phone: $phone
      email: $email
      password: $password
      business_ids: $business_ids
      warehouse_ids: $warehouse_ids
    ) {
      id
      name
      email
      phone
      status
      supplierBusinesses {
        id
        business_name
      }
    }
  }
`;
export const UPDATE_STAFF = gql`
  mutation UpdateStaff(
    $id: ID!
    $name: String
    $business_ids: [ID!]
    $warehouse_ids: [ID!]
  ) {
    updateStaff(
      id: $id
      name: $name
      business_ids: $business_ids
      warehouse_ids: $warehouse_ids
    ) {
      id
      name
      supplierBusinesses {
        id
      }
    }
  }
`;
export const DEACTIVATE_STAFF = gql`
  mutation DeactivateStaff($id: ID!) {
    deactivateStaff(id: $id) {
      id
      name
      email
      status
      phone
    }
  }
`;
export const ACTIVATE_STAFF = gql`
  mutation ActivateStaff($id: ID!) {
    activateStaff(id: $id) {
      id
      name
      email
      status
      phone
    }
  }
`;
export const CREATE_PAYMENT_TYPE = gql`
  mutation ($name: String!, $logo: Upload) {
    createPaymentType(input: { name: $name, logo: $logo }) {
      id
      name
      status
    }
  }
`;

export const UPDATE_PAYMENT_TYPE = gql`
  mutation ($id: ID!, $input: UpdatePaymentTypeInput!) {
    updatePaymentType(id: $id, input: $input) {
      id
      name
      logo
    }
  }
`;
export const UPDATE_MINIMUM_STOCK_LEVEL = gql`
  mutation ($id: ID!, $input: UpdateStockInput!) {
    updateStock(id: $id, input: $input) {
      id
      minimum_stock_level
    }
  }
`;

export const UPDATE_USER = gql`
  mutation (
    $id: ID!
    $name: String!
    $password: String
    $email: String
    $profile_image: Upload
  ) {
    updateUser(
      id: $id
      input: {
        name: $name
        email: $email
        password: $password
        profile_image: $profile_image
      }
    ) {
      id
      name
      phone
      email
      profile_image
    }
  }
`;
export const CREATE_AGENT = gql`
  mutation CreateAgentSupplier($retailer_id: ID!) {
    createAgentSupplier(retailer_id: $retailer_id) {
      id
      retailer {
        id
      }
      supplier {
        id
        user {
          id
        }
      }
      created_at
    }
  }
`;

export const UPDATE_PROFILE = gql`
  mutation ($name: String!, $email: String, $profile_image: Upload) {
    selfUpdateUser(
      input: { name: $name, email: $email, profile_image: $profile_image }
    ) {
      id
      name
      email
      profile_image
    }
  }
`;
export const CHANGE_PASSWORD = gql`
  mutation (
    $current_password: String!
    $password: String!
    $password_confirmation: String!
  ) {
    updatePassword(
      input: {
        current_password: $current_password
        password: $password
        password_confirmation: $password_confirmation
      }
    ) {
      status
    }
  }
`;

//ROles
export const ATTACH_ROLE = gql`
  mutation ($user_id: ID!, $role: String!) {
    attachRole(user_id: $user_id, role: $role) {
      id
      name
      roles {
        id
        name
      }
    }
  }
`;

export const DETTACH_ROLE = gql`
  mutation ($user_id: ID!, $role: String!) {
    detachRole(user_id: $user_id, role: $role) {
      id
      name
      roles {
        id
        name
      }
    }
  }
`;

// Loan Provider Staff Mutations
export const CREATE_LOAN_PROVIDER_STAFF = gql`
  mutation CreateLoanProviderStaff(
    $name: String!
    $email: String!
    $phone: String!
    $temporary_password: String!
    $role: String!
  ) {
    createLoanProviderStaff(
      name: $name
      email: $email
      phone: $phone
      temporary_password: $temporary_password
      role: $role
    ) {
      id
      provider_id
      user_id
      role
      is_active
      user {
        id
        name
        email
        phone
      }
    }
  }
`;

export const UPDATE_LOAN_PROVIDER_STAFF = gql`
  mutation UpdateLoanProviderStaff(
    $id: ID!
    $name: String
    $email: String
    $phone: String
    $role: String
    $is_active: Boolean
  ) {
    updateLoanProviderStaff(
      id: $id
      name: $name
      email: $email
      phone: $phone
      role: $role
      is_active: $is_active
    ) {
      id
      provider_id
      user_id
      role
      is_active
      user {
        id
        name
        email
        phone
      }
    }
  }
`;

export const DELETE_LOAN_PROVIDER_STAFF = gql`
  mutation DeleteLoanProviderStaff($id: ID!) {
    deleteLoanProviderStaff(id: $id) {
      id
    }
  }
`;

export const TOGGLE_LOAN_PROVIDER_STAFF_STATUS = gql`
  mutation ToggleLoanProviderStaffStatus($id: ID!) {
    toggleLoanProviderStaffStatus(id: $id) {
      id
      is_active
    }
  }
`;
